import React from 'react';
import { LucideIcon } from 'lucide-react';

/**
 * SectionHeader Component
 * Consistent header style used across the app.
 */
export const SectionHeader = ({ 
  icon: Icon, 
  title, 
  description, 
  rightElement 
}: { 
  icon: LucideIcon; 
  title: string; 
  description?: string; 
  rightElement?: React.ReactNode 
}) => (
  <div className="flex items-center gap-3 sm:gap-4">
    <div className="flex h-8 w-8 sm:h-10 sm:w-10 items-center justify-center rounded-xl bg-blue-50 border border-blue-100 flex-shrink-0">
      <Icon className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
    </div>
    <div className="flex-1 min-w-0 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">{title}</h3>
        {description && <p className="text-xs sm:text-sm text-gray-500 mt-0.5">{description}</p>}
      </div>
      {rightElement && (
        <div className="flex-shrink-0">
          {rightElement}
        </div>
      )}
    </div>
  </div>
);
